// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2b8WU","row":"Node_row__2kt1E","label":"Node_label__10V8v","footer":"Node_footer__3qSG4"};